
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import { type WideCardType } from '@xt/client/types/home.d'
import WideCard from './card/wideCard.vue'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import SwiperBtn from './swiperBtn/index.vue'

@Observer
@Component({
  components: {
    NewSwiper,
    WideCard,
    SwiperBtn
  }
})
export default class SelfCourse extends Mixins(MixinsHomeClick) {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  data: WideCardType[][] = []

  activeIndex: number = 0

  get dataSource() {
    return this.$store.$homeV2.dataSource?.selfStudyCourse
  }

  handleChange(index) {
    this.activeIndex = index
  }

  handleClickMore() {
    if (this.dataSource?.more) {
      this.onClickEvent(this.dataSource.more)
      return
    }

    window.open('/product/list?typeCurrent=4&directionCurrent=0')
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {
    this.data = lodash.chunk(this.dataSource?.list, 3)
  }

  updated(): void {}

  destroyed(): void {}
}
